import {getJumpNumbersSet} from "../../../storage/user";

export function promptForJumpNumber(value) {
    let jumpNumbersSet = getJumpNumbersSet();
    if (!jumpNumbersSet || !validateNumberField(value)) {
        return false;
    }
    return jumpNumbersSet.has(parseInt(value));
}

export function validateTextField(value) {
    return value.length > 0;
}

export function validateNumberField(value) {
    return !isNaN(value) && value >= 0;
}

export function validateTimestamp(value) {
    return !isNaN(value) && value >= 0;
}

export function validateDropzone(value) {
    return value.length > 0;
}